import { RefObject, useEffect, useRef } from 'react';

const CHECK_INTERVAL_MS = 100;
const MIN_VISIBLE_MS = 1000;

function isAdBlockInView(rect: DOMRect, viewportHeight: number): boolean {
  const blockHeight = rect.height;

  if (blockHeight <= viewportHeight) {
    return rect.top >= 0 && rect.bottom <= viewportHeight;
  }

  return rect.bottom >= viewportHeight && rect.top < viewportHeight;
}

export type UseAdBlockViewOptions = {
  minVisibleMs?: number;
  checkIntervalMs?: number;
};

export type UseAdBlockViewParams = {
  elementRef: RefObject<HTMLElement | null>;
  onAdView?: () => void;
  disabled?: boolean;
} & UseAdBlockViewOptions;

export function useAdBlockView({
  elementRef,
  onAdView,
  disabled = false,
  minVisibleMs = MIN_VISIBLE_MS,
  checkIntervalMs = CHECK_INTERVAL_MS,
}: UseAdBlockViewParams): void {
  const accumulatedMsRef = useRef(0);
  const hasFiredRef = useRef(false);
  const intervalIdRef = useRef<ReturnType<typeof setInterval> | null>(null);

  useEffect(() => {
    if (disabled || !onAdView) return;

    const el = elementRef.current;
    if (!el) return;

    intervalIdRef.current = setInterval(() => {
      if (hasFiredRef.current) return;
      if (document.visibilityState !== 'visible') return;

      const rect = el.getBoundingClientRect();
      const viewportHeight = window.innerHeight;

      if (!isAdBlockInView(rect, viewportHeight)) {
        accumulatedMsRef.current = 0;
        return;
      }

      accumulatedMsRef.current += checkIntervalMs;

      if (accumulatedMsRef.current >= minVisibleMs) {
        hasFiredRef.current = true;
        accumulatedMsRef.current = 0;
        onAdView();
      }
    }, checkIntervalMs);

    return () => {
      if (intervalIdRef.current) {
        clearInterval(intervalIdRef.current);
        intervalIdRef.current = null;
      }
      accumulatedMsRef.current = 0;
    };
  }, [elementRef, onAdView, disabled, minVisibleMs, checkIntervalMs]);
}
import { RefObject, useEffect, useRef } from 'react';

const CHECK_INTERVAL_MS = 100;
const MIN_VISIBLE_MS = 1000;

function isAdBlockInView(rect: DOMRect, viewportHeight: number): boolean {
  const blockHeight = rect.height;

  if (blockHeight <= viewportHeight) {
    return rect.top >= 0 && rect.bottom <= viewportHeight;
  }

  return rect.bottom >= viewportHeight && rect.top < viewportHeight;
}

export type UseAdBlockViewOptions = {
  minVisibleMs?: number;
  checkIntervalMs?: number;
};

export type UseAdBlockViewParams = {
  elementRef: RefObject<HTMLElement | null>;
  onAdView?: () => void;
  disabled?: boolean;
} & UseAdBlockViewOptions;

export function useAdBlockView({
  elementRef,
  onAdView,
  disabled = false,
  minVisibleMs = MIN_VISIBLE_MS,
  checkIntervalMs = CHECK_INTERVAL_MS,
}: UseAdBlockViewParams): void {
  const accumulatedMsRef = useRef(0);
  const hasFiredRef = useRef(false);
  const intervalIdRef = useRef<ReturnType<typeof setInterval> | null>(null);

  useEffect(() => {
    if (disabled || !onAdView) return;

    const el = elementRef.current;
    if (!el) return;

    intervalIdRef.current = setInterval(() => {
      if (hasFiredRef.current) return;
      if (document.visibilityState !== 'visible') return;

      const rect = el.getBoundingClientRect();
      const viewportHeight = window.innerHeight;

      if (!isAdBlockInView(rect, viewportHeight)) {
        accumulatedMsRef.current = 0;
        return;
      }

      accumulatedMsRef.current += checkIntervalMs;

      if (accumulatedMsRef.current >= minVisibleMs) {
        hasFiredRef.current = true;
        accumulatedMsRef.current = 0;
        onAdView();
      }
    }, checkIntervalMs);

    return () => {
      if (intervalIdRef.current) {
        clearInterval(intervalIdRef.current);
        intervalIdRef.current = null;
      }
      accumulatedMsRef.current = 0;
    };
  }, [elementRef, onAdView, disabled, minVisibleMs, checkIntervalMs]);
}
